import React, { useEffect, useRef, useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../utils/BaseUrl";
import { useNavigate, useParams } from "react-router-dom";
import SpinerLoading from "../../../common/Loading/SpinerLoading";
import CircleLoading from "../../../common/Loading/CircleLoading";
import Swal from "sweetalert2";
import TraingleLoading from "../../../common/Loading/TraingleLoading";
import ManditoryStar from "../../templates/ManditoryStar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AdminCarrerForm = () => {
  const [carrerData, setCarrerData] = useState({
    title: "",
    description: "",
    location: "",
    type: "",
    responsibilities: "",
    requirements: "",
    joinus: "",
    position: "",
    deadline: "",
    salary: "",
    mode: "",
    experience: "",
    category: "",
  });

  console.log(carrerData,"carrerData");
  

  const checkSumbit = () => {
    let status = true;

    if (
      carrerData.title !== ''&&
      carrerData.description !=='' &&
      carrerData.location !== '' &&
      carrerData.type !== '' &&
      carrerData.responsibilities!=='' &&
      carrerData.requirements !== '' &&
      carrerData.joinus !== ''&&
      carrerData.position !== ''&&
      carrerData.deadline !== ''&&
      carrerData.salary !== ''&&
      carrerData.mode !== ''&&
      carrerData.experience !== ''&&
      carrerData.category !== ''
     
    ) {
      status = false;
    } else {
      status = true;
    }
    return status;
  };
  console.log(carrerData.description.length,'carrerData.de');

  const [datas, setData] = useState("");
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];

  const { id } = useParams();
  const navigate = useNavigate();
  const modeOptions = ["Hybrid", "WFH", "On-site", "Regular"];
  const type = ["Full-time", "Part-Time", "InternShip"];

  const editorRef = useRef(null);
  const quillInstance = useRef(null);
  const [editorContent, setEditorContent] = useState("");

  const { data,isLoading } = useQuery({
    queryKey: "getjobById",
    queryFn: () =>
      axios.get(`${BASEURL}job/${id}`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      setCarrerData({
        title: response.title,
        description: response.description,
        location: response.location,
        type: response.type,
        responsibilities: response.joinus,
        requirements: response.requirements,
        joinus: response.joinus,
        position: response.position,
        deadline: response.deadline,
        salary: response.salary,
        mode: response.mode,
        experience: response.experience,
        category: response.category,
      });
    },
  });
  const handleChange = (e) => {
    const newData = { ...carrerData };

    newData[e.target.name] = e.target?.value;

    setCarrerData(newData);
  };

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}job`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Job Created Successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/carrer");
      });
    },
  });

  const editMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}job/${id}`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Job Updated Successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/carrer");
      });
    },
  });

  const handleUpdate = (e) => {
    editMutation.mutate(carrerData);
  };

  const handleAdd = (e) => {
    mutation.mutate(carrerData);
  };
  let previousLength = 0;

  // const handleInput = (event) => {
  //   const bullet = "\u21D2";
  //   const newLength = event.target.value.length;
  //   const characterCode = event.target.value.substr(-1).charCodeAt(0);

  //   if (newLength > previousLength) {
  //     if (characterCode === 10) {
  //       event.target.value = `${event.target.value}${bullet} `;
  //     } else if (newLength === 1) {
  //       event.target.value = `${bullet} ${event.target.value}`;
  //     }
  //   }

  //   previousLength = newLength;
  //   // if (event?.target?.name == "requirements") {
  //   setCarrerData({
  //     ...carrerData,

  //     [event.target?.name]: event?.target?.value,
  //   });
  //   // }

  //   setData(event?.target?.value);
  // };

  const handleDescription = (e) => {
    setCarrerData({
      ...carrerData,
      description: e,
    });
  };
  const handlerequirements = (e) => {
    setCarrerData({
      ...carrerData,
      requirements: e,
    });
  };

  const handlejoinus = (e) => {
    setCarrerData({
      ...carrerData,
      joinus: e,
    });
  };

  const handleresponsibilities = (e) => {
    setCarrerData({
      ...carrerData,
      responsibilities: e,
    });
  };

  return (
    <div>
      <AdminTabelHeader
        title={id ? "Edit Carrers" : "Add Careers"}
        btnStatus={false}
      />
      {((id && isLoading) || mutation.isLoading || editMutation.isLoading) && <TraingleLoading />}

      <div className="p-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <ManditoryStar title={"job name"} />

            <input
              name="title"
              value={carrerData.title}
              onChange={(e) => handleChange(e)}
              // className={`input`}
              className={`input ${
                carrerData.title!== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
              type="text"
            />
          </div>
          <div>
            <ManditoryStar title={"Location"} />

            <input
              name="location"
              value={carrerData.location}
              onChange={(e) => handleChange(e)}
              // className={`input`}
              className={`input ${
                carrerData.location !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
              type="text"
            />
          </div>
          <div>
            <ManditoryStar title={"Department"} />

            <input
              name="category"
              value={carrerData.category}
              onChange={(e) => handleChange(e)}
              // className={`input`}
              className={`input ${
                carrerData.category !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
              type="text"
            />
          </div>
          <div>
            <ManditoryStar title={"Experience"} />

            <input
              name="experience"
              value={carrerData.experience}
              onChange={(e) => handleChange(e)}
              // className={`input`}
              className={`input ${
                carrerData.experience !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
              type="text"
            />
          </div>
          <div>
            <ManditoryStar title={"Position"} />

            <input
              name="position"
              value={carrerData.position}
              onChange={(e) => handleChange(e)}
              // className={`input`}
              className={`input ${
                carrerData.position !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
              type="text"
            />
          </div>
          <div>
            <ManditoryStar title={"Salary"} />

            <input
              name="salary"
              value={carrerData.salary}
              onChange={(e) => handleChange(e)}
              // className={`input`}
              className={`input ${
                carrerData.salary !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
              type="text"
            />
          </div>

          <div>
            <ManditoryStar title={"type"} />

            <select
              name="type"
              value={carrerData.type}
              onChange={(e) => handleChange(e)}
              // className={`input `}
              className={`input ${
                carrerData.type !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
            >
              <option value="">Select Mode</option>
              {type?.map((v, i) => (
                <option key={i} value={v}>
                  {v}
                </option>
              ))}
            </select>
          </div>
          <div>
            <ManditoryStar title={"mode"} />

            <select
              name="mode"
              value={carrerData.mode}
              onChange={(e) => handleChange(e)}
              // className={`input `}
              className={`input ${
                carrerData.mode !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
            >
              <option value="">Select Mode</option>
              {modeOptions?.map((v, i) => (
                <option key={i} value={v}>
                  {v}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div>
          <div className="grid grid-cols-1">
            <div className="my-2 mb-14">
              <ManditoryStar title={"job context"} />

              {/* <textarea
              name="description"
              className={`textarea`}
              type="text"
              value={carrerData?.description}
              onChange={(e) => handleChange(e)}
              rows="10"
            /> */}
              <ReactQuill
                value={carrerData?.description}
                onChange={handleDescription}
                style={{ height: "200px" }}
              />
            </div>
            <div className="my-2 mb-14">
              <ManditoryStar title={"job Requirements"} />

              {/* <textarea
              name="requirements"
              value={carrerData?.requirements}
              onInput={(e) => handleInput(e)}
              className={`textarea`}
              type="text"
            /> */}
              <ReactQuill
                value={carrerData?.requirements}
                onChange={handlerequirements}
                style={{ height: "200px" }}
              />
            </div>
            <div className="my-2 mb-14">
              <ManditoryStar title={"job Responsibility"} />

              {/* <textarea
              name="responsibilities"
              value={carrerData.responsibilities}
              onInput={(e) => handleInput(e)}
              className={`textarea`}
              type="text"
            /> */}
              <ReactQuill
                value={carrerData.responsibilities}
                onChange={handleresponsibilities}
                style={{ height: "200px" }}
              />
            </div>
            <div className="my-2 mb-14">
              <ManditoryStar title={"why join us"} />
              {/* 
            <textarea
              name="joinus"
              value={carrerData.joinus}
              onInput={(e) => handleInput(e)}
              className={`textarea`}
              type="text"
            /> */}
              <ReactQuill
                value={carrerData?.joinus}
                onChange={handlejoinus}
                style={{ height: "200px" }}
              />
            </div>
            <div>
              <ManditoryStar title={"deadline"} />

              <input
                name="deadline"
                value={carrerData.deadline}
                onChange={(e) => handleChange(e)}
                // className={`input`}
                className={`input ${
                  carrerData.deadline !== ""
                    ? "input-success"
                    // : newsCardData.heading === ""
                    // ? "input-error"
                    : ""
                }`}
                type="date"
                min={formattedDate}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end my-4 ">
        <button
            onClick={() => navigate(-1)}
            // disabled={checkSubmit()}
            className={"formSubmit mr-8 cursor-pointer "}
          >
            Cancel
          </button>
          <button
            onClick={id ? (e) => handleUpdate(e) : (e) => handleAdd(e)}
            // className={`formSubmit`}
            disabled={checkSumbit()}
            className={`formSubmit  ${
              checkSumbit() ? "cursor-not-allowed " : "cursor-pointer"
            } `}
          >
            {id ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminCarrerForm;
